import React, { useEffect, useState } from "react";
import { Box, Button, Container, Card, Typography, List, ListItem, ListItemText, Divider, Grid, ListItemIcon, IconButton, CircularProgress, Chip } from "@mui/material";
import {
    Dialog, DialogActions, DialogContent, DialogTitle, RadioGroup, ToggleButtonGroup, ToggleButton,
    FormControlLabel, Radio, FormLabel, FormControl, TextField
} from "@mui/material";
import { Public, InfoOutlined, AccountBalanceWalletOutlined, } from '@mui/icons-material';

import { useNavigate, useLocation } from "react-router-dom";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { AddSharp, CancelOutlined, MoreVert } from "@mui/icons-material";
import { UrlConstant } from "../../../commom/UrlConstant";
import Axios from "../../../config/axios";
import moment from "moment";
import { getUserFromLocalStorage } from "../../../utils/utils";
import Swal from "sweetalert2";
import Successpopup from "../SharedComponent/Successpopup";
import ConfirmPopup from "../Popups/ConfirmPopup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import WireInstructionsDisplay from "../Cards/WireInstructionsDisplay";
import LinkIcon from '@mui/icons-material/Link';
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { login } from "../../../Redux/authSlice";
import WireInstructionsInternational from "../Cards/WireInstructionsInternational";
import { trackEvent } from "../../../config/firebase";
import { usePriceFormatter } from "../../../hooks";
import { Constant } from "../../../commom/Constants";
import DepositBonusPopup from "../Popups/DepositBonusPopup";

type AccountType = 'stock' | 'crypto';
type BankAccount = {
    [key: string]: any;
};

const Transfer: React.FC = () => {
    const navigation = useNavigate()
    const [wireError, setWireError] = useState<string | null>(null);
    const user = getUserFromLocalStorage();
    const location = useLocation();
    const dispatch = useAppDispatch();
    const canLinkBank = location.state?.canLinkBank || false;
    const isAU = location.state?.isAus || false;
    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingBalance, setLoadingBalance] = useState(false);
    const [loadingBankAccounts, setLoadingBankAccounts] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [transferType, setTransferType] = useState("Incoming")
    const [transferMethod, setTransferMethod] = useState<'ach' | 'wire'>(canLinkBank ? 'ach' : 'wire');
    const [wireInstructions, setWireInstructions] = useState<any>(null);
    const [loadingWire, setLoadingWire] = useState(false);
    const [transferList, setTransferList] = useState([])
    const [finalDataList, setFinalDataList] = useState([])
    const [bankAccountsList, setBankAccountsList] = useState<BankAccount[]>([]);
    const [currentItem, setCurrentItem] = useState<any>({})
    const [selectedBank, setSelectedBank] = React.useState("");
    const [accountBalnce, setAccountBalnce] = React.useState("");
    // const [enteredAmount, setAmount] = React.useState(0);
    const [showPopup, setShowPopup] = useState(false);
    const [msg, setmsg] = useState('');
    const [Success, setSuccess] = useState(false);
    const [heading, setheading] = useState('');
    const [shouldRefreshList, setShouldRefreshList] = useState(false);
    const [openconfirm, setOpenconfirm] = useState(false);
    const [achFeePercentage, setAchFeePercentage] = useState<number>(0);
    const [kycData, setKycData] = useState<any>(null);
    const formatter = usePriceFormatter();
    const currencyInfo = useAppSelector((state) => state.currency);
    const [timeLeft, setTimeLeft] = useState("00:00:00");
    const [showBonusPopup, setShowBonusPopup] = useState(false);
    useEffect(() => {
        if (!kycData?.depositBonus?.windowEndsAt) return;

        const updateTimer = () => {
            const endTime = new Date(
                kycData.depositBonus.windowEndsAt
            ).getTime();

            const now = Date.now();

            const difference = endTime - now;

            if (difference <= 0) {
                setTimeLeft("00:00:00");
                return;
            }

            const hours = Math.floor(difference / (1000 * 60 * 60));
            const minutes = Math.floor(
                (difference % (1000 * 60 * 60)) / (1000 * 60)
            );
            const seconds = Math.floor(
                (difference % (1000 * 60)) / 1000
            );

            setTimeLeft(
                `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
            );
        };

        updateTimer();

        const interval = setInterval(updateTimer, 1000);

        return () => clearInterval(interval);
    }, [kycData?.depositBonus?.windowEndsAt]);

    const accountType: AccountType = location.state?.onboardingType === 'stock' ? 'stock' : 'crypto';

    const calculateFee = (amount: number) => {
        const fee = (amount * achFeePercentage) / 100;
        const total = amount + fee;
        return { fee: parseFloat(fee.toFixed(2)), total: parseFloat(total.toFixed(2)) };
    }

    const getKycStatus = async () => {
        try {
            const response = await Axios.get(UrlConstant.Sumsub.CheckAccountStatus);
            if (response?.data?.success === true) {
                setKycData(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching KYC status:", error);
        }
    }

    useEffect(() => {
        getKycStatus();
    }, [])

    // Dynamic text based on account type
    // const transferTexts = {
    //     stock: {
    //         incomingTitle: "Transfer to Wolfpack Brokerage Services Account",
    //         incomingDesc: "Transfer money from your bank account to your Wolfpack Brokerage Services Account",
    //         outgoingTitle: "Transfer to your Bank",
    //         outgoingDesc: "Transfer money from your Wolfpack Brokerage Services Account to your bank",
    //         fundsTitle: "Funds Available for Withdraw",
    //         withdrawNote: "Withdrawable amount will be available in 2 business days."
    //     },
    //     crypto: {
    //         incomingTitle: "Deposit to SFox Crypto Account",
    //         incomingDesc: "Transfer money from your bank account to your SFox Crypto Account",
    //         outgoingTitle: "Withdraw from SFox Crypto Account",
    //         outgoingDesc: "Transfer money from your SFox Crypto account to your bank",
    //         fundsTitle: "Funds Available for Withdraw",
    //         withdrawNote: "Withdrawable amount will be available after blockchain confirmation."
    //     }
    // };

    const currentTransferTexts = {
        incomingTitle: "Deposit Funds to Your Account",
        incomingDesc: "Transfer money from your linked bank account to your account",
        outgoingTitle: "Withdraw Funds to Your Bank",
        outgoingDesc: "Send money from your account back to your linked bank account",
        fundsTitle: "Funds Available for Withdrawal",
        withdrawNote: "Processing time may vary depending on your bank and transfer method."
    };

    const handleTransferType = (type) => {
        setTransferType(type)
    }

    const getValidationSchema = (transferType: string, accountBalnce: number) =>
        Yup.object().shape({
            amount: Yup.number()
                .typeError("Amount must be a number")
                .positive("Amount must be greater than zero")
                .required("Amount is required")
                .test(
                    "max",
                    `Amount exceeds available balance of ${formatter.amount(accountBalnce).display}`,
                    function (value) {
                        if (transferType === "Outgoing") {
                            if (!value) return true;
                            if (Number(accountBalnce) <= 0) {
                                return this.createError({ message: "No funds available for withdrawal" }); // ✅ handle zero balance case
                            }
                            return value <= Number(accountBalnce);
                        }
                        return true;
                    }
                ),
        });

    const handleOpen = () => {
        setOpen(true);
    };

    const handleSelectMethod = (method: 'ach' | 'wire') => {
        setTransferMethod(method);
    }

    const fetchWireInstructions = async () => {
        try {
            setLoadingWire(true);
            setWireError(null);
            const response = await Axios.get(UrlConstant.AeroPay.GetWireInstructions);
            if (response?.data?.status === 'success') {
                setWireInstructions(response.data.data || null);
            }
        } catch (error: any) {
            console.error('Error fetching wire instructions:', error?.response?.data || error.message);
            setWireInstructions(null);
            const msg = error?.response?.data?.error || 'Failed to fetch wire instructions.';
            setWireError(msg);
        } finally {
            setLoadingWire(false);
        }
    }
    const handlleDetailsModel = (item) => {
        setCurrentItem(item)
        setOpen2(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleClose2 = () => {
        setOpen2(false);
    };
    const onClosedialog = () => {
        setOpenconfirm(false)
    }
    const opendialog = async () => {
        handleClose2()
        await setOpenconfirm(true);
        console.log(openconfirm)
    }
    const handleCancel = (transactionId: string) => {
        onCancelTransfer(transactionId)
    };

    // Get List API's
    const getTransferList = async (direction) => {
        setLoading(true);
        try {
            let transactions = [];

            if (accountType === "crypto") {
                const response = await Axios.get(UrlConstant.AeroPay.transferHistory, {
                    params: {
                        userId: user?._id,
                        direction: direction.toUpperCase(),
                        type: 'deposit,withdrawal'
                    }
                });
                const rawData = response.data?.data || [];

                transactions = rawData.map(item => {
                    let display_status = 'PENDING';
                    const statusUpper = item.status?.toUpperCase();

                    switch (statusUpper) {
                        case 'COMPLETED':
                            display_status = 'COMPLETE';
                            break;
                        case 'CANCELLED':
                            display_status = 'CANCELED';
                            break;
                        case 'FAILED':
                            display_status = 'FAILED';
                            break;
                        case 'REVERSED':
                            display_status = 'REVERSED';
                            break;
                        case 'PROCESSING':
                            display_status = 'PROCESSING';
                            break;
                        case 'PENDING':
                        case 'INITIATED':
                        case 'SENT_TO_BANK':
                        case 'BANK_APPROVAL':
                            display_status = 'PENDING';
                            break;
                        default:
                            display_status = statusUpper || 'PENDING';
                    }

                    return {
                        createdAt: item.createdAt,
                        transferIdNumber: item.transactionId || item._id,
                        amount: Math.abs(item.amount),
                        display_status: display_status,
                        statusDescription: item.statusHistory?.[item.statusHistory.length - 1]?.status || item.status,
                        currency: item.currency || "USD",
                        type: item.direction,
                        transferTime: item.initiatedAt,
                    };
                });
            } else {
                const response = await Axios.get(
                    UrlConstant.Transfer.GetTransferList.replace("{dir}", direction)
                );
                transactions = response.data?.data || [];
            }

            setTransferList(transactions);
        } catch (error) {
            console.error("ERRR : ", error);
        } finally {
            setLoading(false);
        }
    };

    const getAdminSettings = async () => {
        try {
            const response = await Axios.get(UrlConstant.Transfer.GetACHFee);
            if (response?.data?.status === 'success') {
                setAchFeePercentage(response.data.data.deposit_fees ?? 0);
            }
        } catch (error) {
            console.error("Failed to fetch admin settings:", error);
        }
    };

    const getBankAccounts = async () => {
        setLoadingBankAccounts(true);
        try {
            let resData;
            if (accountType === 'crypto') {
                const response = await Axios.get(UrlConstant.AeroPay.Getbankdetails);
                resData = response.data;
                const newData = resData?.data?.bankAccounts?.filter((item) => item.status === "verified").map(item => ({
                    ...item,
                    bankName: item.bankName,
                    bankAccountType: item.accountType
                }));
                console.log("Bank Accounts: ", newData);
                if (newData && newData.length) {
                    setBankAccountsList(newData);
                    setSelectedBank(newData[0]?.bankAccountId || "");
                }
            } else {
                const data = {
                    "accountId": user?.tradingblock_application_id
                }
                const response = await Axios.post(
                    UrlConstant.Transfer.GetBankAccounts, data
                );
                resData = response.data;
                const newData = resData?.data.filter((item) => item.status.toUpperCase() === "APPROVED");
                if (newData.length) {
                    setBankAccountsList(newData)
                    setSelectedBank(newData[0]?.bankAccountId || "");
                }
            }
        } catch (error: any) {
            console.error("ERRR : ", error);
        } finally {
            setLoadingBankAccounts(false);
        }
    };

    const getAccountBalance = async () => {
        setLoadingBalance(true);
        try {
            let availableBalance;
            if (accountType === 'crypto') {
                const currency = currencyInfo.code?.toLowerCase() || 'usd';

                if (!currency) {
                    setAccountBalnce("0");
                    return;
                }

                const response = await Axios.get(UrlConstant.User.GetUserBalance, {
                    params: { type: 'fiat', currency }
                });
                const fiatObj = Array.isArray(response.data.data.balances)
                    ? response.data.data.balances.find(item => item.currency === currency)
                    : null;
                availableBalance = fiatObj?.withdrawable || 0;
            } else {
                const data = {
                    accountId: user?.tradingblock_application_id
                };
                const response = await Axios.post(UrlConstant.Transfer.CheckBalance, data);
                availableBalance = response.data?.data?.Payload?.availableForWithdrawal || 0;
            }
            setAccountBalnce(availableBalance);
        } catch (error: any) {
            console.error("Error fetching balance:", error.response?.data || error.message);
        } finally {
            setLoadingBalance(false);
        }
    };

    const groupByMonth = (data) => {
        return data.reduce((acc, item) => {
            const date = new Date(item.createdAt);
            const monthYear = date.toLocaleString("default", { month: "long", year: "numeric" });

            if (!acc[monthYear]) {
                acc[monthYear] = { monthYear, items: [] };
            }
            acc[monthYear].items.push(item);

            return acc;
        }, {});
    };

    useEffect(() => {
        getTransferList(transferType)
    }, [transferType])

    useEffect(() => {
        getBankAccounts();
        getAdminSettings();
    }, []);

    useEffect(() => {
        if (currencyInfo.loading) return;
        getAccountBalance();
    }, [currencyInfo.loading]);

    useEffect(() => {
        if (transferMethod !== 'wire') return;

        const selectedBankObj = bankAccountsList && bankAccountsList.length
            ? bankAccountsList.find((b: any) => b.id === selectedBank) || (bankAccountsList.length === 1 ? bankAccountsList[0] : null)
            : null;

        const isInternationalBank = !!selectedBankObj?.international_bank;

        if (!isInternationalBank) {
            fetchWireInstructions();
        }
    }, [selectedBank, transferMethod, bankAccountsList]);

    // useEffect(() => {
    //     setAmount(0)
    // }, [transferType, transferList])

    useEffect(() => {
        if (transferList.length) {
            // Sort by year and month, newest first
            const sortedData = transferList.sort((a: any, b: any) => {
                const dateA = new Date(a.createdAt);
                const dateB = new Date(b.createdAt);

                // First, sort by year (descending)
                if (dateB.getFullYear() !== dateA.getFullYear()) {
                    return dateB.getFullYear() - dateA.getFullYear();
                }

                // If years are the same, sort by month (descending)
                return dateB.getMonth() - dateA.getMonth();
            });

            // Group by month after sorting
            const groupByData = groupByMonth(sortedData);
            setFinalDataList(groupByData)
        } else {
            setFinalDataList([])
        }
    }, [transferList]);

    const onDeposite = async (amountParam: number | string) => {
        const currency = currencyInfo.code.toLowerCase() || 'usd';

        setSubmitLoading(true);
        try {
            const amountToSend = Number(amountParam);
            let resData;

            if (accountType === 'crypto') {
                const payload = {
                    amount: Number(amountToSend),
                    bankAccountId: Number(selectedBank),
                    currency,
                };
                const response = await Axios.post(
                    UrlConstant.AeroPay.depositAmount,
                    payload
                );
                resData = response.data;
            } else {
                const data = {
                    "AccountId": user?.tradingblock_application_id,
                    "Amount": amountToSend,
                    "RelationshipId": selectedBank
                };
                const response = await Axios.post(
                    UrlConstant.Transfer.DepositeAmount,
                    data
                );
                resData = response.data;
            }

            if (resData.status) {
                if (Constant.ENV === "production") {
                    trackEvent("funding_completed", {
                        source: `Amount: ${amountToSend},
                    Currency: ${resData?.data?.currency || 'usd'},
                    TransferType: deposit,
                    Method: ${transferMethod}`,
                    });
                }
                if (resData?.data?.achHold && user) {
                    const updatedUser = {
                        ...user,
                        achHold: resData?.data?.achHold
                    };

                    dispatch(login(updatedUser));
                }

                setheading("Success");
                setSuccess(true);
                setShowPopup(true);
                setmsg(`Deposit successful.`);
                setShouldRefreshList(true);
                handleClose();
            }
        } catch (error: any) {
            setheading('Error');
            setSuccess(false);
            setShowPopup(true);
            setmsg(error.response?.data?.message ?? "Failed to Deposit");
            console.error("ERRR : ", error);
        } finally {
            setSubmitLoading(false);
        }
    };

    const onWithdraw = async (amountParam?: number | string) => {
        const currency = currencyInfo.code.toLowerCase() || 'usd';
        setSubmitLoading(true);
        try {
            const amountToSend = Number(amountParam);
            let resData;
            if (accountType === 'crypto') {
                const payload = {
                    bankAccountId: Number(selectedBank),
                    amount: amountToSend,
                    currency,
                };
                const response = await Axios.post(
                    UrlConstant.AeroPay.withdrawAmount,
                    payload
                );
                resData = response.data;
            } else {
                const data = {
                    "AccountId": user?.tradingblock_application_id,
                    "RequestedAmount": amountToSend,
                    "RelationshipId": selectedBank
                };
                const response = await Axios.post(
                    UrlConstant.Transfer.WithdrawAmount,
                    data
                );
                resData = response.data;
            }
            if (resData.status === 'success') {
                setheading("Success");
                setSuccess(true);
                setShowPopup(true);
                setmsg(`Withdraw successfull.`);
                setShouldRefreshList(true);
                handleClose();
            }
        } catch (error: any) {
            setheading('Error');
            setSuccess(false);
            setShowPopup(true);
            setmsg(error.response?.data?.message ?? "Failed to Withdraw");
            console.error("ERRR : ", error);
        } finally {
            setSubmitLoading(false);
        }
    };


    const onCancelTransfer = async (transactionId: String) => {
        setLoading(true);
        try {
            if (accountType === 'stock') {
                const data = {
                    accountId: user?.tradingblock_application_id,
                    transferId: currentItem?.transferIdNumber
                };
                await Axios.post(UrlConstant.Transfer.CancelTransfer, data);
            }
            else if (accountType === 'crypto') {
                const data = {
                    transactionId: transactionId
                }
                await Axios.post(
                    UrlConstant.User.CancelWithdrawRequest,
                    data
                );
            }

            // Common success handling
            setheading("Success");
            setSuccess(true);
            setShowPopup(true);
            setmsg(`Transfer cancellation successful.`);
            setShouldRefreshList(true);
            handleClose2();

        } catch (error: any) {
            // Common error handling
            setheading('Error');
            setSuccess(false);
            setShowPopup(true);
            setmsg(
                error.response?.data?.data?.message ??
                error.response?.data?.error ??
                "Failed to cancel transfer."
            );
            console.error("ERRR : ", error);
        } finally {
            setLoading(false);
        }
    };


    const handleChangeBank = (event: any) => {
        setSelectedBank(String(event.target.value));
    };

    const closePopup = () => {
        setShowPopup(false);
        if (shouldRefreshList) {
            getTransferList(transferType);
            getAccountBalance()
            setShouldRefreshList(false);
        }
    };

    useEffect(() => {
        if (bankAccountsList?.length > 0) {
            const defaultBank = bankAccountsList.find(
                (bank: any) => bank.isSelected === true
            );

            if (defaultBank) {
                setSelectedBank(defaultBank.bankAccountId);
            }
        }
    }, [bankAccountsList]);

    return (
        <Container
            maxWidth={false}
            className="bg-color"
            style={{
                minHeight: "calc(100vh -  71px - 143px)",
                width: "100%",
                padding: '30px !important'
            }}
        >
            {loading && (
                <Box
                    position="fixed"
                    top={0}
                    left={0}
                    width="100vw"
                    height="100vh"
                    bgcolor="rgba(0, 0, 0, 0.5)"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    style={{
                        backdropFilter: "blur(5px)",
                        zIndex: 9999,
                    }}
                >
                    <CircularProgress color="primary" />
                </Box>
            )}
            <Typography
                className="text-secondary"
                sx={{ marginBottom: "20px", paddingTop: '30px' }}
            >
                {" "}
                <span
                    onClick={() => navigation(-1)}
                    style={{ color: "#4A7AF2", cursor: "pointer" }}
                >
                    More Options{" "}
                </span>{" "}
                / Transfer
            </Typography>
            <Box sx={{ display: "flex", gap: '20px', mb: '20px', color: "#fff" }}>
                {/* Sidebar */}
                <Box
                    sx={{
                        width: "400px",
                        backgroundColor: "#FFFFFF1A",
                        borderRadius: '20px', border: "1px solid #FFFFFF2A",
                        padding: '20px',
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        height: 'fit-content'
                    }}
                >
                    {/* Transfer Options */}
                    <Card
                        sx={{
                            backgroundColor: transferType == "Incoming" ? "var(--Orange-10, #F2674A1A)" : "#FFFFFF2A",
                            padding: '10px',
                            marginBottom: 2,
                            border: transferType == "Incoming" ? "1px solid var(--Orange-100, #F2674A)" : '1px solid #FFFFFF2A',
                            borderRadius: '20px',
                            cursor: "pointer"
                        }}
                        onClick={() => { handleTransferType("Incoming") }}

                    >
                        <Box display='flex' justifyContent='space-between' gap='10px'>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 5.55859H22" stroke={transferType == "Incoming" ? " #F2674A" : '#FFFFFF'} stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M14.22 2H19.78C21.56 2 22 2.44 22 4.2V8.31C22 10.07 21.56 10.51 19.78 10.51H14.22C12.44 10.51 12 10.07 12 8.31V4.2C12 2.44 12.44 2 14.22 2Z" stroke={transferType == "Incoming" ? " #F2674A" : '#FFFFFF'} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M2 17.0586H12" stroke={transferType == "Incoming" ? " #F2674A" : '#FFFFFF'} stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4.22 13.5H9.78C11.56 13.5 12 13.94 12 15.7V19.81C12 21.57 11.56 22.01 9.78 22.01H4.22C2.44 22.01 2 21.57 2 19.81V15.7C2 13.94 2.44 13.5 4.22 13.5Z" stroke={transferType == "Incoming" ? " #F2674A" : '#FFFFFF'} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M22 15C22 18.87 18.87 22 15 22L16.05 20.25" stroke={transferType == "Incoming" ? " #F2674A" : '#FFFFFF'} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M2 9C2 5.13 5.13 2 9 2L7.95001 3.75" stroke={transferType == "Incoming" ? " #F2674A" : '#FFFFFF'} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <Box>
                                <Typography variant="subtitle1" className="text-white" lineHeight='22px' gutterBottom>
                                    {currentTransferTexts.incomingTitle}
                                </Typography>
                                <Typography variant="caption" className="text-secondary">
                                    {currentTransferTexts.incomingDesc}
                                </Typography>
                            </Box>
                        </Box>
                    </Card>
                    <Card
                        sx={{
                            backgroundColor: transferType == "Outgoing" ? "var(--Orange-10, #F2674A1A)" : "#FFFFFF2A",
                            padding: '10px',
                            marginBottom: 2,
                            border: transferType == "Outgoing" ? "1px solid var(--Orange-100, #F2674A)" : '1px solid #FFFFFF2A',
                            borderRadius: '20px',
                            cursor: "pointer"
                        }}
                        onClick={() => { handleTransferType("Outgoing") }}
                    >
                        <Box display='flex' justifyContent='space-between' gap='10px'>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.37 2.14984L21.37 5.74982C21.72 5.88982 22 6.30981 22 6.67981V9.99982C22 10.5498 21.55 10.9998 21 10.9998H3C2.45 10.9998 2 10.5498 2 9.99982V6.67981C2 6.30981 2.28 5.88982 2.63 5.74982L11.63 2.14984C11.83 2.06984 12.17 2.06984 12.37 2.14984Z" stroke={transferType == "Outgoing" ? " #F2674A" : '#FFFFFF'} stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M22 22H2V19C2 18.45 2.45 18 3 18H21C21.55 18 22 18.45 22 19V22Z" stroke={transferType == "Outgoing" ? " #F2674A" : '#FFFFFF'} stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M4 18V11" stroke={transferType == "Outgoing" ? " #F2674A" : '#FFFFFF'} stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8 18V11" stroke={transferType == "Outgoing" ? " #F2674A" : '#FFFFFF'} stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 18V11" stroke={transferType == "Outgoing" ? " #F2674A" : '#FFFFFF'} stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M16 18V11" stroke={transferType == "Outgoing" ? " #F2674A" : '#FFFFFF'} stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M20 18V11" stroke={transferType == "Outgoing" ? " #F2674A" : '#FFFFFF'} stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M1 22H23" stroke={transferType == "Outgoing" ? " #F2674A" : '#FFFFFF'} stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 8.5C12.8284 8.5 13.5 7.82843 13.5 7C13.5 6.17157 12.8284 5.5 12 5.5C11.1716 5.5 10.5 6.17157 10.5 7C10.5 7.82843 11.1716 8.5 12 8.5Z" stroke={transferType == "Outgoing" ? " #F2674A" : '#FFFFFF'} stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                            <Box>
                                <Typography variant="subtitle1" lineHeight='22px' className="text-white" gutterBottom>
                                    {currentTransferTexts.outgoingTitle}
                                </Typography>
                                <Typography variant="caption" className="text-secondary" >
                                    {currentTransferTexts.outgoingDesc}
                                </Typography>
                            </Box>
                        </Box>
                    </Card>

                    {/* Funds Available Section */}
                    <Card
                        sx={{
                            padding: '28px 20px',
                            background: "linear-gradient(#141414, #F2674A)",
                            height: '276px',
                            width: '360px',
                            borderRadius: '10px'
                        }}
                    >
                        <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_1886_8016)">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0785 22.0715C10.0785 29.2701 15.5192 33.9091 21.916 33.9091C21.916 26.6739 18.1361 20.3475 10.0785 22.0715Z" fill="#BAED2C" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.0785 22.0742C10.0785 29.2728 15.5192 33.9117 21.916 33.9117C18.3921 28.8623 14.4461 24.9165 10.0785 22.0742Z" fill="#A0D904" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M33.7535 22.0715C33.7535 29.2701 28.3127 33.9091 21.916 33.9091C21.916 26.6739 25.6958 20.3475 33.7535 22.0715Z" fill="#BAED2C" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M33.7535 22.0742C33.7535 29.2728 28.3127 33.9117 21.916 33.9117C25.4399 28.8623 29.3858 24.9165 33.7535 22.0742Z" fill="#A0D904" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M22.9004 37.7863C22.9004 38.3299 22.4596 38.7707 21.916 38.7707C21.3723 38.7707 20.9316 38.3299 20.9316 37.7863V18.3594C20.9316 17.8157 21.3723 17.375 21.916 17.375C22.4596 17.375 22.9004 17.8157 22.9004 18.3594V37.7863Z" fill="#8BBD00" />
                                <path d="M24.6865 19.8519C29.624 18.3284 32.3915 13.0906 30.8679 8.15314C29.3443 3.21566 24.1066 0.448164 19.1691 1.97176C14.2316 3.49535 11.4641 8.73308 12.9877 13.6706C14.5113 18.608 19.749 21.3755 24.6865 19.8519Z" fill="#F9AC00" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M21.6239 20.2596C16.5943 20.1051 12.5644 15.9799 12.5644 10.913C12.5644 5.84619 16.5943 1.72081 21.6239 1.56641C26.6534 1.72081 30.6834 5.84605 30.6834 10.9129C30.6834 15.9798 26.6535 20.1051 21.6239 20.2594V20.2596Z" fill="#FCDB35" />
                                <path d="M21.916 18.3715C26.0367 18.3715 29.3771 15.031 29.3771 10.9104C29.3771 6.78969 26.0367 3.44922 21.916 3.44922C17.7953 3.44922 14.4548 6.78969 14.4548 10.9104C14.4548 15.031 17.7953 18.3715 21.916 18.3715Z" fill="#F19A00" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M22.3959 3.46484C26.2929 3.71234 29.3771 6.9508 29.3771 10.9102C29.3771 14.8697 26.2928 18.1081 22.3959 18.3556C18.4989 18.1081 15.4146 14.8697 15.4146 10.9102C15.4146 6.9508 18.4989 3.71234 22.3959 3.46484Z" fill="#F9AC00" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M48.9624 22.543C54.8762 24.8748 59.9127 33.1898 61.7378 40.2692C64.7994 52.1445 58.0044 54.6079 46.8638 54.8022C35.7233 54.6079 28.9281 52.1445 31.9898 40.2692C33.815 33.1898 38.8515 24.8748 44.7653 22.543H48.9624Z" fill="#DEDEDE" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M45.0518 54.7472C35.0006 54.3051 29.098 51.4857 31.9898 40.2692C33.815 33.1898 38.8515 24.8748 44.7653 22.543H45.3382C51.252 24.8748 56.2885 33.1898 58.1137 40.2692C61.0055 51.4857 55.1031 54.3051 45.0518 54.7472Z" fill="white" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M45.1856 23.9755L42.1542 23.9843C35.2963 14.592 36.9125 11.2475 40.0978 12.2385C41.0393 12.5314 41.6267 13.0308 42.1225 13.439C43.0104 14.1703 43.7182 14.511 44.476 13.4352C46.1253 11.0945 47.6026 11.0945 49.2518 13.4352C50.0096 14.5109 50.7174 14.1701 51.6053 13.439C52.1012 13.0308 52.6885 12.5314 53.63 12.2385C56.8153 11.2475 58.4315 14.592 51.5737 23.9843L48.5422 23.9755C47.909 23.9793 47.3864 23.9811 46.864 23.9811C46.3416 23.9811 45.8189 23.9793 45.1856 23.9755Z" fill="#DEDEDE" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M45.1856 23.9753L45.0517 23.9758L44.918 23.9753L44.628 23.977L43.2397 23.9811C42.8877 23.9811 42.5358 23.9803 42.1501 23.9786C35.2972 14.5906 36.9132 11.2478 40.0979 12.2385C41.0396 12.5314 41.6268 13.0308 42.1227 13.439C43.0106 14.1703 43.7183 14.5109 44.4762 13.4352C46.1256 11.0945 47.6025 11.0945 49.2519 13.4352C50.0098 14.5109 50.7177 14.1701 51.6054 13.439C51.8508 13.2369 52.1186 13.0126 52.4406 12.802C53.3087 14.2258 52.4731 17.7873 47.9537 23.9786C47.5679 23.9803 47.216 23.9811 46.864 23.9811L45.4756 23.977L45.1856 23.9753Z" fill="white" />
                                <path d="M40.7652 22.2423H52.9626C53.9232 22.2423 54.703 23.0222 54.703 23.9827C54.703 24.9435 53.9231 25.7232 52.9626 25.7232H40.7652C39.8046 25.7232 39.0247 24.9433 39.0247 23.9827C39.0247 23.0221 39.8046 22.2422 40.7652 22.2422V22.2423Z" fill="#873F30" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M50.0182 22.2422H40.7652C39.808 22.2422 39.0248 23.0253 39.0248 23.9826C39.0248 24.9398 39.808 25.7231 40.7652 25.7231H50.0182C50.9754 25.7231 51.7586 24.9399 51.7586 23.9827C51.7586 23.0255 50.9756 22.2422 50.0182 22.2422Z" fill="#A34F41" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M45.8803 44.8999C44.2582 44.6545 42.7399 43.8986 42.0479 42.635C41.7876 42.1585 41.9618 41.5606 42.4389 41.2997C42.9168 41.038 43.5146 41.2137 43.7763 41.6901C44.5077 43.0275 47.4379 43.3935 48.9495 42.6412C49.4239 42.4046 49.7472 41.9728 49.8177 41.4855C49.8523 41.236 49.8496 40.7609 49.428 40.3725C49.0464 40.0213 48.3971 39.7076 47.5504 39.467C47.2562 39.3829 46.9343 39.3071 46.5926 39.2271C45.5074 38.9696 44.2765 38.6788 43.3892 37.9901C42.5751 37.3577 42.0884 36.5037 42.0213 35.5846C41.9562 34.6878 42.2871 33.8115 42.9546 33.1159C43.6309 32.4121 44.6881 31.9458 45.88 31.7839V30.3754C45.88 29.8311 46.3199 29.3906 46.8636 29.3906C47.4072 29.3906 47.8485 29.8312 47.8485 30.3754V31.7929C49.5214 32.0302 50.8275 32.8143 51.4389 33.9483C51.6973 34.4268 51.5176 35.0239 51.039 35.2815C50.5612 35.5397 49.9632 35.3609 49.7057 34.8816C49.3967 34.3076 48.5881 33.8805 47.5435 33.7375C46.2638 33.5632 44.9618 33.8683 44.3754 34.479C44.0995 34.7664 43.9605 35.108 43.9857 35.4416C44.0107 35.8014 44.2229 36.1444 44.5957 36.4345C45.1454 36.8609 46.1119 37.0893 47.0467 37.3109C47.3944 37.3929 47.7529 37.4777 48.0879 37.5732C49.2462 37.9025 50.1463 38.3574 50.7625 38.9242C51.5529 39.6541 51.9196 40.6879 51.7665 41.7621C51.6045 42.8913 50.8805 43.8796 49.8258 44.4029C49.2503 44.6902 48.5685 44.8715 47.8487 44.9474V46.3421C47.8487 46.8863 47.4074 47.3269 46.8637 47.3269C46.3201 47.3269 45.8802 46.8863 45.8802 46.3421V44.9L45.8803 44.8999Z" fill="#F2674A" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M47.1345 53.8821C48.2338 52.0323 46.8413 49.6892 44.6912 49.7705C27.0218 49.7705 26.9906 35.403 10.4626 56.6589L19.2091 65.8282C23.1048 61.8995 27.7357 61.7181 32.8437 62.0236C35.6299 62.1902 38.9548 62.5925 42.0052 62.5252C46.2676 62.4309 48.8798 61.274 52.6227 59.2914C56.8839 57.034 64.2901 52.5381 65.5822 50.8398C67.4312 48.4089 65.0441 46.1194 62.2236 47.7477C58.9067 49.6628 50.124 53.8514 45.5993 55.1134C46.284 54.8165 46.8188 54.4131 47.1344 53.8819L47.1345 53.8821Z" fill="#FDB0A0" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M47.1345 53.8821C48.2338 52.0323 46.8413 49.6892 44.6912 49.7705C27.0218 49.7705 26.9906 35.403 10.4626 56.6589L17.214 63.7367C21.2958 59.7111 26.1352 59.5259 31.4675 59.8449C34.4046 60.0205 37.9098 60.4446 41.1258 60.3736C45.6192 60.2743 48.373 59.0547 52.3188 56.9644C56.7667 54.6083 64.4638 49.9391 65.9374 48.1093C65.3259 47.1713 63.8467 46.8107 62.2238 47.7477C58.9068 49.6628 50.1241 53.8514 45.5995 55.1134C46.2842 54.8165 46.819 54.4131 47.1345 53.8819V53.8821Z" fill="#FFCEC0" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M47.1346 53.8833C47.9921 52.4404 47.3333 50.6973 45.9814 50.0391C46.9599 51.1108 46.3036 52.6322 44.769 53.1905C43.9196 53.4994 42.775 53.6454 41.5314 53.6758C38.2829 53.7552 34.5454 52.9932 33.0674 52.224C32.5464 51.9531 31.9043 52.1559 31.6335 52.6769C31.3626 53.1979 31.5654 53.84 32.0864 54.1107C33.7942 54.9995 37.9986 55.8829 41.5811 55.7953C43.0608 55.7591 44.4604 55.5537 45.5994 55.1146C46.2841 54.8178 46.8189 54.4143 47.1344 53.8832L47.1346 53.8833Z" fill="#FDB0A0" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.76558 57.9228L9.81488 53.8735C10.6098 53.0786 11.9105 53.0787 12.7054 53.8735L22.3322 63.5001C23.1271 64.2949 23.127 65.5957 22.3322 66.3907L18.2829 70.44L5.76572 57.9227L5.76558 57.9228Z" fill="#2A93FC" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.76562 57.9228L9.81492 53.8735C10.6094 53.0789 11.9094 53.0787 12.7043 53.8725L12.7053 53.8735L20.2866 61.4548C21.0815 62.2497 21.0814 63.5504 20.2866 64.3454L16.2373 68.3947L5.76548 57.9229L5.76562 57.9228Z" fill="#4EB1FC" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.932 15.784C19.7982 15.5617 18.7643 14.9915 18.2614 14.0721C17.9997 13.5949 18.1754 12.997 18.6525 12.7361C19.1289 12.4751 19.7269 12.6501 19.9884 13.1265C20.3917 13.8632 22.2564 14.1778 23.2602 13.6782C23.5138 13.5522 23.6791 13.3338 23.7157 13.0797C23.7326 12.9604 23.7313 12.7319 23.532 12.5475C23.366 12.3951 23.023 12.1721 22.3214 11.9727C22.12 11.9157 21.8964 11.8628 21.6585 11.8066C20.8627 11.6182 19.9613 11.4047 19.2847 10.88C18.6435 10.3825 18.2613 9.70538 18.2077 8.97399C18.1541 8.2575 18.4172 7.55944 18.9458 7.00833C19.4186 6.51684 20.1276 6.17541 20.9319 6.02353V5.27316C20.9319 4.7295 21.3718 4.28906 21.916 4.28906C22.4602 4.28906 22.9002 4.72964 22.9002 5.27316V6.02944C24.0546 6.25022 24.9571 6.83522 25.4021 7.6597C25.6597 8.13825 25.4807 8.73534 25.0028 8.99297C24.5229 9.25116 23.9272 9.07228 23.6696 8.59374C23.4994 8.27859 22.985 8.02027 22.3573 7.93491C21.552 7.82508 20.7149 8.00874 20.3666 8.37211C20.2283 8.51513 20.1599 8.67783 20.1707 8.83027C20.1863 9.04514 20.3536 9.21727 20.4913 9.32442C20.8302 9.58739 21.5114 9.74869 22.1113 9.89044C22.3608 9.94936 22.6163 10.0104 22.8596 10.0789C23.7217 10.3243 24.3969 10.6673 24.8652 11.0997C25.4949 11.6799 25.7857 12.5027 25.665 13.3575C25.5369 14.2495 24.9663 15.0276 24.1366 15.4405C23.7674 15.6246 23.3459 15.7521 22.9002 15.8233V16.5514C22.9002 17.0951 22.4589 17.5355 21.916 17.5355C21.373 17.5355 20.9319 17.0949 20.9319 16.5514V15.7839L20.932 15.784Z" fill="#FFEB87" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1886_8016">
                                    <rect width="72" height="72" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>

                        <Typography variant="h6" sx={{ mt: '10px' }} fontWeight={600} className="text-white" gutterBottom>
                            {currentTransferTexts.fundsTitle}
                        </Typography>
                        <Typography variant="h4" fontSize='45px' gutterBottom className="text-white" sx={{ fontWeight: "bold" }}>
                            {
                                loadingBalance ? <CircularProgress size={20} color="inherit" /> : `${formatter.balance(accountBalnce).display}`
                            }
                        </Typography>
                        <Typography variant="caption" sx={{ color: "#ffffff90" }}>
                            {currentTransferTexts.withdrawNote}
                        </Typography>
                    </Card>
                </Box>

                {/* Main Content */}
                <Box sx={{ flex: 1, backgroundColor: "#FFFFFF1A", borderRadius: '20px', border: "1px solid #FFFFFF2A", padding: '20px 20px 0px 20px' }}>

                    <>
                        {Object.entries(finalDataList).length === 0 && (
                            <Box
                                sx={{
                                    height: "60vh",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    textAlign: "center",
                                    gap: 2,
                                }}
                            >
                                <Typography variant="h5" className="text-white">
                                    {transferType === "Incoming"
                                        ? "No Deposit Transactions"
                                        : "No Withdrawal Transactions"}
                                </Typography>

                                <Typography variant="body2" className="text-secondary">
                                    {transferType === "Incoming"
                                        ? "You currently have no deposits. Please click the Deposit button to add funds."
                                        : "You currently have no withdrawals. Please click the Withdraw button to make a withdrawal."}
                                </Typography>

                                <Button
                                    onClick={() => {
                                        if (transferType === "Incoming") {
                                            if (Constant.ENV === "production") {
                                                trackEvent("funding_started", {
                                                    source: "deposit_screen",
                                                })
                                            }
                                        }
                                        handleOpen();
                                    }}
                                    variant="contained"
                                    className="btn btn-primary"
                                    startIcon={<AddSharp />}
                                    sx={{ mt: 1 }}
                                >
                                    {transferType === "Incoming" ? "Deposit Now" : "Withdraw Now"}
                                </Button>
                            </Box>
                        )}

                        {Object.entries(finalDataList).map(([month, { items }]: any, index) => {
                            return (
                                <div key={month}>
                                    <Box>
                                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: '20px' }}>
                                            <Typography variant="h5">
                                                {month}
                                            </Typography>
                                            {index === 0 && (
                                                <Button
                                                    onClick={handleOpen}
                                                    variant="contained"
                                                    sx={{ fontSize: "14px" }}
                                                    className="btn btn-primary"
                                                    color="primary"
                                                    startIcon={<AddSharp />}
                                                >
                                                    {transferType == "Incoming" ? "Deposit" : "Withdraw"}
                                                </Button>
                                            )}
                                        </Box>

                                        {/* Transaction List */}
                                        <Box sx={{}}>
                                            <List sx={{ padding: '0px', maxHeight: '70vh', overflow: 'auto', mb: '20px' }}>
                                                {items?.length && items?.map((transfer) => {
                                                    return (
                                                        <ListItem id={transfer.transferIdNumber} sx={{ backgroundColor: "#FFFFFF2A", borderRadius: '20px', padding: '20px 30px', height: '113px', marginBottom: 1, cursor: "pointer" }} onClick={() => { handlleDetailsModel(transfer) }}>
                                                            <ListItemIcon sx={{ marginRight: '20px' }}>
                                                                <Box height='73px' width='73px' borderRadius='50px' padding='10px 0px' textAlign='center' bgcolor='#FFFFFF1A'>
                                                                    <Typography variant="h5" fontWeight='600' color="#F2674A" mb='0px'>{moment(transfer.createdAt).format("DD")}</Typography>
                                                                    <Typography variant="subtitle2" color="#FFFFFF5A">{moment(transfer.createdAt).format("MMM")}</Typography>
                                                                </Box>
                                                            </ListItemIcon>
                                                            <ListItemText
                                                                primary={
                                                                    <Box display="flex" flexDirection="column">
                                                                        <Typography variant="h5">
                                                                            {moment(transfer.createdAt).format("DD MMM, YYYY")}{" "}
                                                                            <span style={{ color: '#4A7AF2' }}>
                                                                                {moment(transfer.createdAt).format("hh:mm A")}
                                                                            </span>
                                                                        </Typography>
                                                                    </Box>
                                                                }
                                                                secondary={`ID: ${transfer.transferIdNumber}`}
                                                                primaryTypographyProps={{ color: "#fff" }}
                                                                secondaryTypographyProps={{ color: "#FFFFFF", fontSize: '16px' }}
                                                            />

                                                            <Typography
                                                                style={{
                                                                    fontSize: '14px',
                                                                    marginRight: '50px',
                                                                    padding: '5px 20px',
                                                                    borderRadius: '15px',
                                                                    display: 'inline-block',
                                                                    textAlign: 'center',
                                                                    backgroundColor:
                                                                        transfer.display_status === 'PENDING'
                                                                            ? 'rgba(74, 122, 242, 0.2)'
                                                                            : transfer.display_status === 'COMPLETE'
                                                                                ? '#4CAF5033'
                                                                                : transfer.display_status === 'CANCELED'
                                                                                    ? '#F4433633'
                                                                                    : transfer.display_status === 'FAILED'
                                                                                        ? '#F4433633'
                                                                                        : transfer.display_status === 'PROCESSING'
                                                                                            ? '#FF980033'
                                                                                            : '#F4433633',
                                                                    color:
                                                                        transfer.display_status === 'PENDING'
                                                                            ? '#4A7AF2'
                                                                            : transfer.display_status === 'COMPLETE'
                                                                                ? '#4CAF50'
                                                                                : transfer.display_status === 'CANCELED'
                                                                                    ? '#F44336'
                                                                                    : transfer.display_status === 'FAILED'
                                                                                        ? '#F44336'
                                                                                        : transfer.display_status === 'PROCESSING'
                                                                                            ? '#FF9800'
                                                                                            : '#F44336',
                                                                }}
                                                            >
                                                                {transfer.display_status}
                                                            </Typography>

                                                            <Typography sx={{ marginLeft: "auto", fontWeight: '500', fontSize: '28px' }}>{formatter.balance(transfer.amount).display}</Typography>
                                                            <Typography><MoreVert sx={{ fontSize: "32px" }}></MoreVert></Typography>
                                                        </ListItem>
                                                    )
                                                })}

                                            </List>

                                        </Box>
                                    </Box>
                                </div>
                            )
                        }
                        )}
                    </>
                </Box>
            </Box>
            <Dialog sx={{ '.MuiDialog-paper': { margin: "0px", maxWidth: "620px" } }} open={open} onClose={handleClose}>
                <Box width='620px' sx={{ borderRadius: '20px', display: 'flex', flexDirection: 'column', maxHeight: '90vh' }}>
                    <DialogTitle padding='22px 30px'>
                        <Grid container>
                            <Grid item xs={10}>
                                <Box display="flex" alignItems="center" gap={2}>
                                    <Typography variant="h5" className="text-white" sx={{ fontWeight: 600 }}>
                                        {transferType === "Incoming" ? "Deposit" : "Withdraw"}
                                    </Typography>
                                    {/* {transferType === "Incoming" && ( */}
                                    <ToggleButtonGroup
                                        value={transferMethod}
                                        exclusive
                                        onChange={(_, value) => value && handleSelectMethod(value as 'ach' | 'wire')}
                                        sx={{
                                            background: '#23272F',
                                            borderRadius: '12px',
                                            p: 0.5,
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
                                            '& .MuiToggleButton-root': {
                                                color: '#9CA3AF',
                                                fontWeight: 600,
                                                fontSize: '0.95rem',
                                                border: 0,
                                                borderRadius: '10px !important',
                                                px: 3,
                                                py: 1,
                                                transition: 'all 0.2s ease-in-out',
                                                '&:hover': {
                                                    color: 'white',
                                                    background: 'rgba(74, 122, 242, 0.1)',
                                                }
                                            },
                                            '& .Mui-selected': {
                                                background: '#4A7AF2 !important',
                                                color: 'white !important',
                                                boxShadow: '0 4px 12px rgba(74, 122, 242, 0.3)',
                                            },
                                        }}
                                    >
                                        {canLinkBank && <ToggleButton value="ach">ACH</ToggleButton>}
                                        <ToggleButton value="wire">Wire</ToggleButton>
                                    </ToggleButtonGroup>
                                    {/* )} */}
                                </Box>
                            </Grid>
                            <Grid item>
                                <IconButton
                                    onClick={handleClose}
                                    sx={{
                                        transition: 'all 0.2s',
                                        '&:hover': {
                                            background: 'rgba(255, 255, 255, 0.05)',
                                            transform: 'rotate(90deg)',
                                        }
                                    }}
                                >
                                    <CancelOutlined sx={{ height: '36px', width: '36px', color: '#9CA3AF' }} />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </DialogTitle>
                    <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.1)' }} />
                    <DialogContent
                        sx={{
                            padding: '20px 30px',
                            overflow: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            scrollbarWidth: 'thin',
                            scrollbarColor: 'rgba(255, 255, 255, 0.3) transparent',
                            '&::-webkit-scrollbar': {
                                width: '6px'
                            },
                            '&::-webkit-scrollbar-track': {
                                background: 'transparent',
                                borderRadius: '10px'
                            },
                            '&::-webkit-scrollbar-thumb': {
                                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                borderRadius: '10px',
                                border: '2px solid transparent',
                                backgroundClip: 'padding-box',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 0.35)'
                            },
                        }}
                    >
                        {(() => {
                            // Find the selected bank object (fallback to first bank if only one exists)
                            const selectedBankObj = bankAccountsList && bankAccountsList.length
                                ? bankAccountsList.find((b: any) => b.id === selectedBank) || (bankAccountsList.length === 1 ? bankAccountsList[0] : null)
                                : null;

                            // const isInternationalBank = !!selectedBankObj?.international_bank;
                            // const achBlocked = !!selectedBankObj && (
                            //     selectedBankObj.ach_enabled === false ||
                            //     selectedBankObj.ach_onboarded === false ||
                            //     isInternationalBank
                            // );

                            if (transferMethod === 'ach') {
                                // if (achBlocked) {
                                //     const isInternationalIssue = isInternationalBank;

                                //     return (
                                //         <Box sx={{ p: 2 }}>
                                //             <Box sx={{
                                //                 display: 'flex',
                                //                 gap: 2.5,
                                //                 alignItems: 'flex-start',
                                //             }}>
                                //                 <Box sx={{
                                //                     width: 56,
                                //                     height: 56,
                                //                     borderRadius: '14px',
                                //                     background: 'linear-gradient(135deg, #4A7AF2 0%, #3461D9 100%)',
                                //                     display: 'flex',
                                //                     alignItems: 'center',
                                //                     justifyContent: 'center',

                                //                 }}>
                                //                     {isInternationalIssue ? (
                                //                         <Public sx={{ color: 'white', fontSize: 28 }} />
                                //                     ) : (
                                //                         <LinkIcon sx={{ color: 'white', fontSize: 28 }} />
                                //                     )}
                                //                 </Box>
                                //                 <Box sx={{ flex: 1 }}>
                                //                     <Typography variant="h6" className="text-white" fontWeight={600} sx={{ mb: 1 }}>
                                //                         {isInternationalIssue ? 'International Bank Detected' : 'ACH Not Enabled'}
                                //                     </Typography>
                                //                     <Typography variant="body2" className="text-secondary" sx={{ mb: 2.5, lineHeight: 1.6 }}>
                                //                         {isInternationalIssue ? (
                                //                             <>
                                //                                 ACH transfers are only available for US domestic bank accounts. Your linked bank account
                                //                                 {selectedBankObj?.bankName ? ` (${selectedBankObj.bankName})` : ''} is an international bank.
                                //                                 <Box component="span" sx={{ display: 'block', mt: 1.5, color: '#4A7AF2', fontWeight: 500 }}>
                                //                                     Please use Wire transfer instead or link a US domestic bank account.
                                //                                 </Box>
                                //                             </>
                                //                         ) : (
                                //                             <>
                                //                                 Your linked bank account{selectedBankObj?.bankName ? ` (${selectedBankObj.bankName})` : ''} does not have ACH enabled or has not completed verification. To enable ACH deposits, please onboard and verify your bank account.
                                //                             </>
                                //                         )}
                                //                     </Typography>
                                //                     <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                                //                         {isInternationalIssue ? (
                                //                             <Button
                                //                                 variant="contained"
                                //                                 className="btn btn-primary"
                                //                                 onClick={() => handleSelectMethod('wire')}
                                //                                 sx={{
                                //                                     textTransform: 'none',
                                //                                     fontWeight: 600,
                                //                                     px: 3,
                                //                                     py: 1.25,
                                //                                     borderRadius: '10px',
                                //                                     boxShadow: '0 4px 12px rgba(74, 122, 242, 0.3)',
                                //                                     '&:hover': {
                                //                                         boxShadow: '0 6px 16px rgba(74, 122, 242, 0.4)',
                                //                                     }
                                //                                 }}
                                //                             >
                                //                                 Switch to Wire Transfer
                                //                             </Button>
                                //                         ) : (
                                //                             <Button
                                //                                 variant="contained"
                                //                                 className="btn btn-primary"
                                //                                 onClick={() => navigation('/linkbankaccount', { state: { onboardingType: accountType === 'stock' ? 'stock' : 'crypto' } })}
                                //                                 sx={{
                                //                                     textTransform: 'none',
                                //                                     fontWeight: 600,
                                //                                     px: 3,
                                //                                     py: 1.25,
                                //                                     borderRadius: '10px',
                                //                                     boxShadow: '0 4px 12px rgba(74, 122, 242, 0.3)',
                                //                                     '&:hover': {
                                //                                         boxShadow: '0 6px 16px rgba(74, 122, 242, 0.4)',
                                //                                     }
                                //                                 }}
                                //                             >
                                //                                 Link / Verify Bank Account
                                //                             </Button>
                                //                         )}
                                //                         <Button
                                //                             variant="outlined"
                                //                             onClick={() => navigation('/linkbankaccount', { state: { onboardingType: accountType === 'stock' ? 'stock' : 'crypto' } })}
                                //                             sx={{
                                //                                 textTransform: 'none',
                                //                                 fontWeight: 600,
                                //                                 px: 3,
                                //                                 py: 1.25,
                                //                                 borderRadius: '10px',
                                //                                 borderColor: 'rgba(74, 122, 242, 0.3)',
                                //                                 color: '#4A7AF2',
                                //                                 '&:hover': {
                                //                                     borderColor: '#4A7AF2',
                                //                                     background: 'rgba(74, 122, 242, 0.05)',
                                //                                 }
                                //                             }}
                                //                         >
                                //                             Link Different Account
                                //                         </Button>
                                //                     </Box>
                                //                 </Box>
                                //             </Box>
                                //         </Box>
                                //     );
                                // }

                                // If loading bank accounts, show loading spinner

                                if (loadingBankAccounts) {
                                    return (

                                        <Box sx={{
                                            textAlign: 'center',
                                            py: 4,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: 2.5,
                                            justifyContent: 'center',
                                            minHeight: '300px'
                                        }}>
                                            <CircularProgress />
                                            <Typography className="text-secondary">
                                                Loading your bank accounts...
                                            </Typography>
                                        </Box>
                                    );
                                }

                                // If no bank accounts, show empty state with Link Bank Account button
                                if (bankAccountsList.length === 0) {
                                    return (
                                        <>
                                            {kycData?.depositBonus?.hasDeposited === false && kycData?.depositBonus?.withinWindow === true && (
                                                <div className="deposit-reward-bar">
                                                    <div className="reward-coin">$</div>

                                                    <div className="reward-message">
                                                        Deposit min. ${kycData?.depositBonus?.tiers?.[0]?.minAmount} within
                                                        <strong> {timeLeft} </strong>
                                                        to unlock spin rewards.
                                                    </div>

                                                    <button className="view-offer" onClick={() => setShowBonusPopup(true)}>
                                                        View Offer <span>›</span>
                                                    </button>
                                                </div>
                                            )}
                                            <Box sx={
{
                                                textAlign: 'center',
                                                py: 4,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                gap: 2.5
                                            }}>
                                                <AccountBalanceWalletOutlined sx={{ fontSize: 56, color: 'rgba(255, 255, 255, 0.2)' }} />
                                                <Box>
                                                    <Typography variant="h6" className="text-white" sx={{ fontWeight: 600, mb: 1 }}>
                                                        No Bank Accounts Found
                                                    </Typography>
                                                    <Typography className="text-secondary" sx={{ fontSize: '0.95rem', mb: 2 }}>
                                                        Link a bank account to start using this feature.
                                                    </Typography>
                                                </Box>
                                                <Button
                                                    variant="contained"
                                                    className="btn btn-primary"
                                                    onClick={() => navigation('/linkbankaccount')}
                                                    sx={{
                                                        textTransform: 'none',
                                                        fontWeight: 600,
                                                        px: 4,
                                                        py: 1.5,
                                                        borderRadius: '10px',
                                                        fontSize: '16px',
                                                        boxShadow: '0 4px 12px rgba(74, 122, 242, 0.3)',
                                                        '&:hover': {
                                                            boxShadow: '0 6px 16px rgba(74, 122, 242, 0.4)',
                                                        }
                                                    }}
                                                >
                                                    Link Bank Account
                                                </Button>
                                            </Box>
                                        </>
                                    );
                                }

                                return (
                                    <>
                                        {transferType === "Incoming" && kycData.depositBonus?.hasDeposited === false && kycData.depositBonus?.withinWindow === true && (
                                            <div className="deposit-reward-bar">
                                                <div className="reward-coin">$</div>

                                                <div className="reward-message">
                                                    Deposit min. ${kycData?.depositBonus?.tiers?.[0]?.minAmount} within
                                                    <strong> {timeLeft} </strong>
                                                    to unlock spin rewards.
                                                </div>

                                                <button className="view-offer" onClick={() => setShowBonusPopup(true)}>
                                                    View Offer <span>›</span>
                                                </button>
                                            </div>
                                        )}
                                        <Formik
                                            initialValues={{ amount: '' }}
                                            enableReinitialize
                                            validationSchema={getValidationSchema(transferType, Number(accountBalnce))}
                                            onSubmit={async (values, { setSubmitting }) => {
                                                if (transferType === "Incoming") {
                                                    await onDeposite(values.amount);
                                                } else {
                                                    await onWithdraw(values.amount);
                                                }
                                                setSubmitting(false);
                                            }}
                                        >
                                            {({ isSubmitting, touched, errors, values }) => (
                                                <Form style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                                    <Box sx={{ flex: 1, minHeight: 0 }}>
                                                        {transferType !== "Incoming" && (
                                                            <Box sx={{
                                                                mb: 2.5,
                                                                p: 2,
                                                                background: 'linear-gradient(135deg, rgba(255, 152, 0, 0.05) 0%, rgba(255, 152, 0, 0.02) 100%)',
                                                                borderRadius: '12px',
                                                                border: '1px solid rgba(255, 152, 0, 0.15)',
                                                            }}>
                                                                <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
                                                                    <InfoOutlined sx={{ color: '#FF9800', fontSize: 20, mt: 0.25, flexShrink: 0 }} />
                                                                    <Typography variant="body2" className="text-secondary" sx={{ lineHeight: 1.6 }}>
                                                                        <strong>Note:</strong>{" "}
                                                                        "After your withdrawal, the funds will be processed within 3-6 business days."
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                        )}

                                                        <Box sx={{ marginBottom: '24px' }}>
                                                            <FormControl fullWidth>
                                                                <Typography
                                                                    component="label"
                                                                    htmlFor="amount-field"
                                                                    className="text-secondary"
                                                                    sx={{
                                                                        marginBottom: '10px',
                                                                        fontWeight: 500,
                                                                        fontSize: '0.9rem'
                                                                    }}
                                                                >
                                                                    {transferType === "Incoming" ? "Deposit" : "Withdraw"} Amount
                                                                    <Typography component="span" sx={{ color: '#fa0000', ml: 0.5 }}>
                                                                        *
                                                                    </Typography>
                                                                </Typography>
                                                                <Field
                                                                    as={TextField}
                                                                    id="amount-field"
                                                                    name="amount"
                                                                    placeholder="Enter amount"
                                                                    variant="outlined"
                                                                    className="text-secondary"
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-root': {
                                                                            height: '52px',
                                                                            borderRadius: '12px',
                                                                            transition: 'all 0.2s',
                                                                            '&:hover': {
                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                    borderColor: 'rgba(74, 122, 242, 0.5)',
                                                                                }
                                                                            },
                                                                            '&.Mui-focused': {
                                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                                    borderColor: '#4A7AF2',
                                                                                    borderWidth: '2px',
                                                                                }
                                                                            }
                                                                        }
                                                                    }}
                                                                    error={touched.amount && Boolean(errors.amount)}
                                                                />
                                                                <ErrorMessage name="amount">
                                                                    {msg => (
                                                                        <Typography color="error" fontSize="14px" sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                                            {msg}
                                                                        </Typography>
                                                                    )}
                                                                </ErrorMessage>
                                                                {transferType === "Incoming" && Number(values.amount) > 0 && (() => {
                                                                    const { fee, total } = calculateFee(Number(values.amount));
                                                                    return (
                                                                        <Box sx={{
                                                                            mt: 1.5,
                                                                            p: 1.5,
                                                                            background: 'rgba(242, 103, 74, 0.07)',
                                                                            borderRadius: '10px',
                                                                            border: '1px solid rgba(242, 103, 74, 0.2)',
                                                                            display: 'flex',
                                                                            flexDirection: 'column',
                                                                            gap: 0.5
                                                                        }}>
                                                                            <Box display="flex" justifyContent="space-between">
                                                                                <Typography sx={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.5)' }}>
                                                                                    Deposit Amount
                                                                                </Typography>
                                                                                <Typography sx={{ fontSize: '0.85rem', color: '#fff' }}>
                                                                                    ${Number(values.amount).toFixed(2)}
                                                                                </Typography>
                                                                            </Box>
                                                                            <Box display="flex" justifyContent="space-between">
                                                                                <Typography sx={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.5)' }}>
                                                                                    Service Fee ({achFeePercentage}%)
                                                                                </Typography>
                                                                                <Typography sx={{ fontSize: '0.85rem', color: '#F2674A' }}>
                                                                                    +${fee.toFixed(2)}
                                                                                </Typography>
                                                                            </Box>
                                                                            <Divider sx={{ borderColor: 'rgba(255,255,255,0.08)', my: 0.5 }} />
                                                                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                                                                <Typography sx={{ fontSize: '0.9rem', fontWeight: 600, color: 'rgba(255,255,255,0.8)' }}>
                                                                                    Total Deducted
                                                                                </Typography>
                                                                                <Typography sx={{ fontSize: '0.95rem', fontWeight: 700, color: '#4A7AF2' }}>
                                                                                    ${total.toFixed(2)}
                                                                                </Typography>
                                                                            </Box>
                                                                            <Typography sx={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.35)', mt: 0.5 }}>
                                                                                ${total.toFixed(2)} will be deducted from your bank account (includes {achFeePercentage}% service fee)
                                                                            </Typography>
                                                                        </Box>
                                                                    );
                                                                })()}
                                                                {transferType !== "Incoming" && (
                                                                    <Box sx={{
                                                                        mt: 1.5,
                                                                        p: 1.5,
                                                                        background: 'rgba(74, 122, 242, 0.05)',
                                                                        borderRadius: '10px',
                                                                        border: '1px solid rgba(74, 122, 242, 0.1)'
                                                                    }}>
                                                                        <Typography className="text-white" sx={{ fontSize: '0.9rem', fontWeight: 500 }}>
                                                                            Funds available to withdraw: <Box component="span" sx={{ color: '#4A7AF2', fontWeight: 600 }}>{formatter.amount(accountBalnce).display}</Box>
                                                                        </Typography>
                                                                    </Box>
                                                                )}
                                                            </FormControl>
                                                        </Box>

                                                        <Box>
                                                            <FormControl fullWidth>
                                                                <Typography
                                                                    className="text-secondary"
                                                                    component="label"
                                                                    sx={{
                                                                        marginBottom: "10px",
                                                                        fontSize: "0.9rem",
                                                                        fontWeight: 500
                                                                    }}
                                                                >
                                                                    {transferType !== "Incoming" ? "To" : "From"}
                                                                    <Typography component="span" sx={{ color: '#fa0000', ml: 0.5 }}>
                                                                        *
                                                                    </Typography>
                                                                </Typography>
                                                                <Box
                                                                    sx={{
                                                                        border: "1px solid rgba(255, 255, 255, 0.1)",
                                                                        borderRadius: "12px",
                                                                        padding: "16px",
                                                                        backgroundColor: "rgba(35, 39, 47, 0.3)",
                                                                        maxHeight: '240px',
                                                                        overflowY: 'auto',
                                                                        overflowX: 'hidden',
                                                                        scrollbarWidth: 'thin',
                                                                        scrollbarColor: 'rgba(255, 255, 255, 0.3) transparent',
                                                                        '&::-webkit-scrollbar': {
                                                                            width: '6px',
                                                                        },
                                                                        '&::-webkit-scrollbar-track': {
                                                                            background: 'transparent',
                                                                            borderRadius: '10px',
                                                                        },
                                                                        '&::-webkit-scrollbar-thumb': {
                                                                            backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                                                            borderRadius: '10px',
                                                                            border: '2px solid transparent',
                                                                            backgroundClip: 'padding-box',
                                                                        },
                                                                        '&::-webkit-scrollbar-thumb:hover': {
                                                                            backgroundColor: 'rgba(255, 255, 255, 0.35)',
                                                                        }
                                                                    }}
                                                                >
                                                                    <RadioGroup
                                                                        value={String(selectedBank)}
                                                                        onChange={(e: any) => { handleChangeBank(e) }}
                                                                        sx={{
                                                                            display: "flex",
                                                                            flexDirection: "column",
                                                                            gap: "8px",
                                                                        }}
                                                                    >
                                                                        {bankAccountsList.map((bank: any) => (
                                                                            <FormControlLabel
                                                                                key={bank.bankAccountId}
                                                                                value={String(bank.bankAccountId)}
                                                                                control={
                                                                                    <Radio
                                                                                        sx={{
                                                                                            color: "rgba(255, 255, 255, 0.2)",
                                                                                            '&.Mui-checked': {
                                                                                                color: '#4A7AF2'
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                }
                                                                                label={
                                                                                    <Box display="flex" alignItems="center" gap={1.5} width="100%">
                                                                                        <Typography variant="subtitle1" className="text-white">
                                                                                            {bank?.name} - {bank?.bankName} {bank?.accountLast4 ? `(xxxx${bank.accountLast4})` : ''}
                                                                                        </Typography>
                                                                                        <Typography variant="subtitle1" className="text-white">|</Typography>
                                                                                        <Typography
                                                                                            variant="subtitle1"
                                                                                            sx={{
                                                                                                color: '#4A7AF2',
                                                                                                textTransform: 'capitalize'
                                                                                            }}
                                                                                        >
                                                                                            {bank?.bankAccountType}
                                                                                        </Typography>
                                                                                        {bank?.international_bank && (
                                                                                            <Chip
                                                                                                label="International"
                                                                                                size="small"
                                                                                                sx={{
                                                                                                    height: 22,
                                                                                                    fontSize: '0.75rem',
                                                                                                    background: 'rgba(255, 152, 0, 0.15)',
                                                                                                    color: '#FF9800',
                                                                                                    border: '1px solid rgba(255, 152, 0, 0.3)',
                                                                                                    fontWeight: 600
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                    </Box>
                                                                                }
                                                                                sx={{
                                                                                    margin: 0,
                                                                                    padding: '8px',
                                                                                    borderRadius: '8px',
                                                                                    border: '1px solid transparent',
                                                                                    transition: 'all 0.2s',
                                                                                    '&:hover': {
                                                                                        backgroundColor: 'rgba(74, 122, 242, 0.05)',
                                                                                        borderColor: 'rgba(74, 122, 242, 0.2)',
                                                                                    },
                                                                                    ...(String(selectedBank) === String(bank.bankAccountId) && {
                                                                                        backgroundColor: 'rgba(74, 122, 242, 0.08)',
                                                                                        borderColor: 'rgba(74, 122, 242, 0.3)',
                                                                                    })
                                                                                }}
                                                                            />
                                                                        ))}
                                                                    </RadioGroup>
                                                                </Box>
                                                            </FormControl>
                                                        </Box>
                                                    </Box>
                                                    <Box sx={{ flexShrink: 0, mt: 2 }}>
                                                        <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.1)', mb: 2 }} />
                                                        <DialogActions sx={{ width: '100%', padding: '0px' }}>
                                                            <Button
                                                                disabled={isSubmitting}
                                                                fullWidth
                                                                sx={{ fontSize: '16px', fontWeight: 'bold', padding: "13px 100px" }}
                                                                className="btn btn-primary"
                                                                type="submit"
                                                            >
                                                                {isSubmitting ? (
                                                                    <CircularProgress size={24} sx={{ color: '#ffffff !important' }} />
                                                                ) : (
                                                                    transferType === "Incoming" ? "Deposit Funds" : "Withdraw Funds Request"
                                                                )}
                                                            </Button>
                                                        </DialogActions>
                                                    </Box>
                                                </Form>
                                            )}
                                        </Formik>
                                    </>
                                );
                            }
                            // wire instructions
                            // if (isInternationalBank) {
                            //     return (
                            //         <WireInstructionsInternational
                            //             setheading={setheading}
                            //             setSuccess={setSuccess}
                            //             setShowPopup={setShowPopup}
                            //             setmsg={setmsg}
                            //         />
                            //     );
                            // }
                            if (transferMethod === "wire" && transferType === "Incoming") {
                                return (
                                    <WireInstructionsDisplay
                                        loadingWire={loadingWire}
                                        wireInstructions={wireInstructions}
                                        wireError={wireError}
                                        kycData={kycData}
                                        setheading={setheading}
                                        setSuccess={setSuccess}
                                        setShowPopup={setShowPopup}
                                        setmsg={setmsg}
                                    />
                                );
                            }
                            if (transferMethod === "wire" && transferType === "Outgoing") {
                                return (
                                    <Formik
                                        initialValues={{
                                            accountHolderName: "",
                                            bankName: "",
                                            accountNumber: "",
                                            routingNumber: "",
                                            swiftCode: "",
                                            bsbNumber: "",
                                            amount: ""
                                        }}
                                        validationSchema={Yup.object({
                                            accountHolderName: Yup.string().required("Account holder name is required"),
                                            bankName: Yup.string().required("Bank name is required"),
                                            accountNumber: Yup.string().required("Account number is required"),
                                            bsbNumber: isAU ? Yup.string().required("BSB number is required") : Yup.string(),
                                            routingNumber: !isAU ? Yup.string().required("Routing number is required") : Yup.string(),
                                            swiftCode: (!isAU && !canLinkBank)
                                                ? Yup.string().required("SWIFT code is required")
                                                : Yup.string(),
                                            amount: Yup.number()
                                                .typeError("Amount must be a number")
                                                .positive("Amount must be greater than zero")
                                                .required("Amount is required")
                                                .max(Number(accountBalnce), `Amount exceeds available balance of ${formatter.balance(accountBalnce).display}`)
                                                .min(50, "Minimum withdrawal amount is $50")
                                        })}
                                        onSubmit={async (values, { setSubmitting }) => {
                                            try {
                                                const currency = currencyInfo.code.toLowerCase() || 'usd';
                                                const payload = {
                                                    amount: Number(values.amount),
                                                    accountHolderName: values.accountHolderName,
                                                    accountNumber: values.accountNumber,
                                                    bankName: values.bankName,
                                                    currency,
                                                    ...(isAU
                                                        ? { bsbNumber: values.bsbNumber }
                                                        : { routingNumber: values.routingNumber, swiftCode: values.swiftCode }
                                                    ),
                                                }
                                                const response = await Axios.post(
                                                    UrlConstant.User.CreateUserWithdrawRequest,
                                                    payload
                                                );
                                                setheading("Success");
                                                setSuccess(true);
                                                setmsg(response.data.message || "Your withdrawal request has been submitted successfully.");
                                                setShowPopup(true);
                                                setShouldRefreshList(true);
                                                handleClose();
                                            } catch (error: any) {
                                                console.error(error);
                                                setheading("Error");
                                                setSuccess(false);
                                                setmsg(error?.response?.data?.message || "Something went wrong");
                                                setShowPopup(true);
                                            } finally {
                                                setSubmitting(false);
                                            }
                                        }}
                                    >
                                        {({ handleChange, values, isSubmitting, touched, errors }) => (
                                            <Form style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                                                <Box sx={{ flex: 1 }}>

                                                    {/* Info Banner */}
                                                    <Box sx={{
                                                        mb: 2.5,
                                                        p: 2,
                                                        background: 'linear-gradient(135deg, rgba(255, 152, 0, 0.05) 0%, rgba(255, 152, 0, 0.02) 100%)',
                                                        borderRadius: '12px',
                                                        border: '1px solid rgba(255, 152, 0, 0.15)',
                                                    }}>
                                                        <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
                                                            <InfoOutlined sx={{ color: '#FF9800', fontSize: 20, mt: 0.25, flexShrink: 0 }} />
                                                            <Typography variant="body2" className="text-secondary" sx={{ lineHeight: 1.6 }}>
                                                                <strong>Note:</strong> Wire withdrawals are typically processed within 1–3 business days. Please ensure all bank details are correct before submitting.
                                                            </Typography>
                                                        </Box>
                                                    </Box>

                                                    {/* Available Balance */}
                                                    <Box sx={{
                                                        mb: 2.5,
                                                        p: 1.5,
                                                        background: 'rgba(74, 122, 242, 0.05)',
                                                        borderRadius: '10px',
                                                        border: '1px solid rgba(74, 122, 242, 0.1)'
                                                    }}>
                                                        <Typography className="text-white" sx={{ fontSize: '0.9rem', fontWeight: 500 }}>
                                                            Funds available to withdraw:{' '}
                                                            <Box component="span" sx={{ color: '#4A7AF2', fontWeight: 600 }}>
                                                                {formatter.balance(accountBalnce).display}
                                                            </Box>
                                                        </Typography>
                                                    </Box>

                                                    <Grid container spacing={2}>

                                                        {/* Section Label */}
                                                        <Grid item xs={12}>
                                                            <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.4)', letterSpacing: '0.08em', textTransform: 'uppercase', fontWeight: 600 }}>
                                                                Recipient Bank Details
                                                            </Typography>
                                                        </Grid>

                                                        {/* Account Holder Name */}
                                                        <Grid item xs={12}>
                                                            <Typography component="label" className="text-secondary" sx={{ fontSize: '0.85rem', fontWeight: 500, display: 'block', mb: '8px' }}>
                                                                Account Holder Name <Box component="span" sx={{ color: '#fa0000' }}>*</Box>
                                                            </Typography>
                                                            <TextField
                                                                fullWidth
                                                                name="accountHolderName"
                                                                placeholder="e.g. John Doe"
                                                                value={values.accountHolderName}
                                                                onChange={handleChange}
                                                                error={touched.accountHolderName && Boolean(errors.accountHolderName)}
                                                                helperText={touched.accountHolderName && errors.accountHolderName}
                                                                sx={{
                                                                    '& .MuiOutlinedInput-root': {
                                                                        height: '52px',
                                                                        borderRadius: '12px',
                                                                        transition: 'all 0.2s',
                                                                        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(74, 122, 242, 0.5)' },
                                                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#4A7AF2', borderWidth: '2px' }
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>

                                                        {/* Bank Name */}
                                                        <Grid item xs={12}>
                                                            <Typography component="label" className="text-secondary" sx={{ fontSize: '0.85rem', fontWeight: 500, display: 'block', mb: '8px' }}>
                                                                Bank Name <Box component="span" sx={{ color: '#fa0000' }}>*</Box>
                                                            </Typography>
                                                            <TextField
                                                                fullWidth
                                                                name="bankName"
                                                                placeholder="e.g. Chase Bank"
                                                                value={values.bankName}
                                                                onChange={handleChange}
                                                                error={touched.bankName && Boolean(errors.bankName)}
                                                                helperText={touched.bankName && errors.bankName}
                                                                sx={{
                                                                    '& .MuiOutlinedInput-root': {
                                                                        height: '52px',
                                                                        borderRadius: '12px',
                                                                        transition: 'all 0.2s',
                                                                        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(74, 122, 242, 0.5)' },
                                                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#4A7AF2', borderWidth: '2px' }
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>

                                                        {/* Account Number + Routing Number side by side */}
                                                        <Grid item xs={12} sm={isAU ? 12 : 6}>
                                                            <Typography component="label" className="text-secondary" sx={{ fontSize: '0.85rem', fontWeight: 500, display: 'block', mb: '8px' }}>
                                                                Account Number <Box component="span" sx={{ color: '#fa0000' }}>*</Box>
                                                            </Typography>
                                                            <TextField
                                                                fullWidth
                                                                name="accountNumber"
                                                                placeholder="e.g. 123456789"
                                                                value={values.accountNumber}
                                                                onChange={handleChange}
                                                                error={touched.accountNumber && Boolean(errors.accountNumber)}
                                                                helperText={touched.accountNumber && errors.accountNumber}
                                                                sx={{
                                                                    '& .MuiOutlinedInput-root': {
                                                                        height: '52px',
                                                                        borderRadius: '12px',
                                                                        transition: 'all 0.2s',
                                                                        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(74, 122, 242, 0.5)' },
                                                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#4A7AF2', borderWidth: '2px' }
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>
                                                        {!isAU && (
                                                            <Grid item xs={12} sm={6}>
                                                                <Typography component="label" className="text-secondary" sx={{ fontSize: '0.85rem', fontWeight: 500, display: 'block', mb: '8px' }}>
                                                                    Routing Number <Box component="span" sx={{ color: '#fa0000' }}>*</Box>
                                                                </Typography>
                                                                <TextField
                                                                    fullWidth
                                                                    name="routingNumber"
                                                                    placeholder="e.g. 021000021"
                                                                    value={values.routingNumber}
                                                                    onChange={handleChange}
                                                                    error={touched.routingNumber && Boolean(errors.routingNumber)}
                                                                    helperText={touched.routingNumber && errors.routingNumber}
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-root': {
                                                                            height: '52px',
                                                                            borderRadius: '12px',
                                                                            transition: 'all 0.2s',
                                                                            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(74, 122, 242, 0.5)' },
                                                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#4A7AF2', borderWidth: '2px' }
                                                                        }
                                                                    }}
                                                                />
                                                            </Grid>
                                                        )}


                                                        {/* SWIFT Code */}
                                                        {!isAU && !canLinkBank && (
                                                            <Grid item xs={12}>
                                                                <Typography component="label" className="text-secondary" sx={{ fontSize: '0.85rem', fontWeight: 500, display: 'block', mb: '8px' }}>
                                                                    SWIFT Code <Box component="span" sx={{ color: '#fa0000' }}>*</Box>
                                                                </Typography>
                                                                <TextField
                                                                    fullWidth
                                                                    name="swiftCode"
                                                                    placeholder="e.g. CHASUS33"
                                                                    value={values.swiftCode}
                                                                    onChange={handleChange}
                                                                    error={touched.swiftCode && Boolean(errors.swiftCode)}
                                                                    helperText={touched.swiftCode && errors.swiftCode}
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-root': {
                                                                            height: '52px',
                                                                            borderRadius: '12px',
                                                                            transition: 'all 0.2s',
                                                                            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(74, 122, 242, 0.5)' },
                                                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#4A7AF2', borderWidth: '2px' }
                                                                        }
                                                                    }}
                                                                />
                                                            </Grid>
                                                        )}

                                                        {isAU && (
                                                            <Grid item xs={12}>
                                                                <Typography component="label" className="text-secondary" sx={{ fontSize: '0.85rem', fontWeight: 500, display: 'block', mb: '8px' }}>
                                                                    BSB Number <Box component="span" sx={{ color: '#fa0000' }}>*</Box>
                                                                </Typography>
                                                                <TextField
                                                                    fullWidth
                                                                    name="bsbNumber"
                                                                    placeholder="e.g. 062-000"
                                                                    value={values.bsbNumber}
                                                                    onChange={handleChange}
                                                                    // onBlur={handleBlur}
                                                                    error={touched.bsbNumber && Boolean(errors.bsbNumber)}
                                                                    helperText={touched.bsbNumber && errors.bsbNumber}
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-root': {
                                                                            height: '52px',
                                                                            borderRadius: '12px',
                                                                            transition: 'all 0.2s',
                                                                            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(74, 122, 242, 0.5)' },
                                                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#4A7AF2', borderWidth: '2px' }
                                                                        }
                                                                    }}
                                                                />
                                                            </Grid>
                                                        )}

                                                        {/* Divider before amount */}
                                                        <Grid item xs={12}>
                                                            <Divider sx={{ borderColor: 'rgba(255,255,255,0.08)', my: 0.5 }} />
                                                            <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.4)', letterSpacing: '0.08em', textTransform: 'uppercase', fontWeight: 600, display: 'block', mt: 1 }}>
                                                                Transfer Amount
                                                            </Typography>
                                                        </Grid>

                                                        {/* Amount */}
                                                        <Grid item xs={12}>
                                                            <Typography component="label" className="text-secondary" sx={{ fontSize: '0.85rem', fontWeight: 500, display: 'block', mb: '8px' }}>
                                                                Amount <Box component="span" sx={{ color: '#fa0000' }}>*</Box>
                                                            </Typography>
                                                            <TextField
                                                                fullWidth
                                                                name="amount"
                                                                type="number"
                                                                placeholder="0.00"
                                                                value={values.amount}
                                                                onChange={handleChange}
                                                                error={touched.amount && Boolean(errors.amount)}
                                                                helperText={touched.amount && errors.amount}
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <Typography sx={{ color: 'rgba(255,255,255,0.4)', mr: 1, fontSize: '1.1rem', fontWeight: 500 }}>{currencyInfo.symbol}</Typography>
                                                                    )
                                                                }}
                                                                sx={{
                                                                    '& .MuiOutlinedInput-root': {
                                                                        height: '52px',
                                                                        borderRadius: '12px',
                                                                        transition: 'all 0.2s',
                                                                        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(74, 122, 242, 0.5)' },
                                                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#4A7AF2', borderWidth: '2px' }
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>

                                                    </Grid>
                                                </Box>

                                                {/* Submit Button */}
                                                <Box sx={{ flexShrink: 0, mt: 3 }}>
                                                    <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.1)', mb: 2 }} />
                                                    <DialogActions sx={{ width: '100%', padding: '0px' }}>
                                                        <Button
                                                            type="submit"
                                                            fullWidth
                                                            disabled={isSubmitting}
                                                            className="btn btn-primary"
                                                            sx={{ fontSize: '16px', fontWeight: 'bold', padding: '13px 100px' }}
                                                        >
                                                            {isSubmitting ? (
                                                                <CircularProgress size={24} sx={{ color: '#ffffff !important' }} />
                                                            ) : (
                                                                'Withdraw Request'
                                                            )}
                                                        </Button>
                                                    </DialogActions>
                                                </Box>
                                            </Form>
                                        )}
                                    </Formik>
                                );
                            }
                        })()}
                    </DialogContent>
                </Box>
            </Dialog>
            <Dialog
                open={open2}
                onClose={handleClose2}
                PaperProps={{
                    sx: {
                        borderRadius: "20px",
                        boxShadow: "0px 8px 100px rgba(0,0,0,0.6)",
                        background: "#0f0f14",
                        minWidth: "420px"
                    }
                }}
            >
                {/* HEADER */}
                <DialogTitle sx={{ px: 3, py: 2 }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6" className="text-white">
                            {transferType === "Incoming" ? "Deposit" : "Withdraw"} Amount
                        </Typography>

                        <IconButton onClick={handleClose2}>
                            <CancelOutlined sx={{ fontSize: 28 }} />
                        </IconButton>
                    </Box>
                </DialogTitle>

                <Divider sx={{ borderColor: 'white' }}></Divider>

                {/* CONTENT */}
                <DialogContent sx={{ px: 3, py: 2 }}>
                    {[
                        {
                            label: "Amount",
                            value: `${formatter.balance(currentItem?.amount).display}`
                        },
                        {
                            label: "Status",
                            value: currentItem?.display_status
                        },
                        {
                            label: "Transaction ID",
                            value: currentItem?.transferIdNumber,
                            isLong: true
                        },
                        {
                            label: "Transfer Time",
                            value: moment(currentItem?.transferTime).format(
                                "DD MMM, YYYY hh:mm A"
                            )
                        },
                        ...(currentItem?.bankData?.bankName
                            ? [{ label: "Transfer From", value: currentItem.bankData.bankName }]
                            : []),
                        ...(currentItem?.bankData?.bankAccount
                            ? [
                                {
                                    label: "Account Number",
                                    value: currentItem.bankData.bankAccount
                                }
                            ]
                            : []),
                        ...(currentItem?.bankData?.bankAccountType
                            ? [
                                {
                                    label: "Account Type",
                                    value: currentItem.bankData.bankAccountType
                                }
                            ]
                            : [])
                    ].map((item, i) => (
                        <Box
                            key={i}
                            display="flex"
                            justifyContent="space-between"
                            alignItems="flex-start"
                            mb={2}
                        >
                            <Typography
                                sx={{ color: "rgba(255,255,255,0.6)", fontSize: "14px" }}
                            >
                                {item.label}
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#fff",
                                    fontSize: "14px",
                                    maxWidth: item.isLong ? "220px" : "auto",
                                    wordBreak: item.isLong ? "break-all" : "normal",
                                    textAlign: "right"
                                }}
                            >
                                {item.value}
                            </Typography>
                        </Box>
                    ))}
                </DialogContent>

                {/* 
                {currentItem?.display_status === "PENDING" && (
                    <>
                        <Divider sx={{ borderColor: 'white' }}></Divider>
                        <DialogActions
                            sx={{
                                px: 3,
                                py: 2,
                                justifyContent: "center"
                            }}
                        >
                            <Button
                                onClick={opendialog}
                                sx={{
                                    px: 6,
                                    py: 1.5,
                                    fontWeight: 600,
                                    borderRadius: "30px"
                                }}
                                className="btn btn-primary"
                            >
                                Cancel Transaction
                            </Button>
                        </DialogActions>
                    </>
                )}
                    */}
            </Dialog>
            {showPopup && <Successpopup Heading={heading} Success={Success} onClose={closePopup} Message={msg} />}
            {openconfirm ? <ConfirmPopup onClose={onClosedialog} confirm_process={() => handleCancel(currentItem?.transferIdNumber)} confirmText={'Are you sure you want to Cancel this transaction ?'} /> : null}

            <DepositBonusPopup
                open={showBonusPopup}
                onClose={() => setShowBonusPopup(false)}
                onFundNow={() => setShowBonusPopup(false)}
                tiers={kycData?.depositBonus?.tiers ?? []}
                hideActions
            />
        </Container >
    );
};

export default Transfer;